export const PolicyholderMapper = () => {
  const mapPolicyholderData = (policyholder, response, convertToAddress, formatDate) => {
    const addressFromResponse = convertToAddress(response);

    return {
      ...policyholder,
      id: response?.id || policyholder.id,
      fullName: {
        fullNameUa: response?.fio || policyholder.fullName?.fullNameUa || null,
        fullNameEn: response?.fio_en || policyholder.fullName?.fullNameEn || null,
      },
      taxNumber: response?.identification_number || policyholder.taxNumber || null,
      address: {
        ...policyholder.address,
        city: addressFromResponse?.city || policyholder.address?.city || null,
        street: addressFromResponse?.street || policyholder.address?.street || { nameUa: null, nameEn: null },
        buildingNumber: addressFromResponse?.buildingNumber || policyholder.address?.buildingNumber || null,
        apartmentNumber: addressFromResponse?.apartmentNumber || policyholder.address?.apartmentNumber || null,
        region: addressFromResponse?.region || policyholder.address?.region || null,
      },
      email: response?.email || policyholder.email || null,
      phone: response?.phone || policyholder.phone || null,
      dateOfBirth: formatDate(response?.date_of_birth) || policyholder.dateOfBirth || null,
    };
  };

  const mapDocumentData = (document, responseDocument, formatDate) => {
    return {
      ...document,
      id: responseDocument?.id || null,
      documentType: responseDocument?.document_type || null,
      serialNumber: responseDocument?.serial || null,
      documentNumber: responseDocument?.number || null,
      issuingAuthority: responseDocument?.issued_by || null,
      issueDate: formatDate(responseDocument?.date_of_issue),
      expirationDate: responseDocument?.end_date_of_issue || null,
    };
  };

  const needsPolicyholderLoad = (policyholder) => {
    return policyholder?.id
      && !(
        policyholder?.email
        && policyholder?.taxNumber
        && policyholder?.dateOfBirth
        && policyholder?.address?.city
      );
  };

  const needsDocumentLoad = (document) => {
    return !document?.serialNumber
      && !document?.documentNumber
      && document?.id;
  };

  return {
    mapPolicyholderData,
    mapDocumentData,
    needsPolicyholderLoad,
    needsDocumentLoad,
  };
};